import React from 'react';
import Routes from './routes/index'


const App = () => <Routes/>

export default App;
